<template>
	<div class="slider-confirm" v-show="showSliderContainer">
		<div class="slider-panel">
			<div class="slider-box">
				<span class="close-btn" @click="changeSliderConfirm(false)"></span>
				<p class="title">帐号安全验证</p>
				<div style="height: 74px;">
					<div id="captcha"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
function getTAL_UC() {
	return window.TAL_UC
}

export default {
	name: 'UdcSlider',
	data() {
		return {
			showSliderContainer: false
		}
	},
	methods: {
		sliderConfirm(functionName, functionParams, failCallback) {
			this.showSliderContainer = true
			const TAL_UC = getTAL_UC()
			if (!TAL_UC) return
			const param = {
				slideCallback: functionName,
				slideParams: functionParams,
				failCallback: failCallback || function() {}
			}
			TAL_UC.showSlide(param)
		},
		changeSliderConfirm(bool) {
			this.showSliderContainer = bool
		}
	}
}
</script>

<style lang="less" scoped>
.slider-confirm {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(51, 51, 51, 0.6);
	z-index: 2000;
}
.slider-panel {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 450px;
	margin: 0 20px;
}
.slider-box {
	box-sizing: border-box;
	height: 168px;
	position: relative;
	margin-right: 40px;
	padding-bottom: 40px;
	background: rgba(255, 255, 255, 1);
	border-radius: 6px;
	overflow: hidden;
}
.close-btn {
	position: absolute;
	top: 23px;
	right: 24px;
	display: inline-block;
	width: 22px;
	height: 22px;
	cursor: pointer;
}
.close-btn::after {
	content: '×';
	font-size: 24px;
	line-height: 22px;
	color: #999;
}
.close-btn:hover::after {
	color: #333;
}
.title {
	margin: 22px 0 0 20px;
	font-size: 16px;
	font-weight: 500;
	color: rgba(33, 40, 50, 1);
}
</style>

<style lang="less">
#captcha {
	margin-top: 40px;
}
#nc_1_wrapper {
	margin: 0 auto;
	width: 80%;
}
</style>



// WEBPACK FOOTER //
// module/forgetPassword/src/components/UdcSlider.vue